module.exports = __webpack_public_path__ + "static/media/firebase-init.010d2d65.png";